import React from 'react'
import styled from "styled-components"
import ReactHtmlParser from 'react-html-parser'
import _ from 'lodash'
var Container =styled.div`
    /* font-family:'Roboto'; */
    color:#000000;
    padding-top:20px;
`
var Title_FAQtitle =styled.h2`
color:#333333;
`

var Question = styled.p`
font-weight:bold;
`
var Answer = styled.p`
&* a{
    text-decoration:none;
}
`

export default function FAQ(props) {
    return (
        <Container>
            <Title_FAQtitle>{props.title}</Title_FAQtitle>
            {props.question_list?props.question_list.filter(faq => !_.isEmpty(_.get(faq, 'answer', '')) && !_.includes(_.get(faq, 'answer', ''), '/select')).map((x,index)=><>
            <Question key={"questionFAQ"+index} >{x.question}</Question>
            <Answer key={"answerFAQ"+index} >{ReactHtmlParser(x.answer)}</Answer>
            </>):null}            
            
        </Container>

    )
}
